<template>
	<div class="accordion__list">

		<div
			class="accordion__list__items"
			v-for="(accordion, index) in JSON.parse(accordions)"
			:key="index"
		>
			<accordion-list-item :title="accordion.title" :text="accordion.text"></accordion-list-item>
		</div>
	</div>
</template>

<script>
import AccordionListItem from './AccordionListItem.vue';

export default {
	data() {
		return {
			window: {
				width: 0,
				height: 0,
			},
		};
	},

	props: {
		title: {},
		accordions: {},
	},

	computed: {},

	watch: {},

	methods: {
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},
	},

	components: {
		AccordionListItem,
	},

	created() {
		window.addEventListener('load', this.handleResize);
		window.addEventListener('resize', this.handleResize);
	},
	destroyed() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.accordion__list {
	margin-bottom: 2rem;

	&__items {
		margin-bottom: 0;
	}
}

</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/AccordionList.vue